/* ============
 * Tax Module State
 * ============
 */

export default {
  view: 'card',
  orderViewType: 'all',
};



// WEBPACK FOOTER //
// ./src/app/store/modules/view/state.js